export const ZENDESK = 'https://memrisebeta.zendesk.com/hc';
export const ZENDESK_WEB_MICROPHONE_ARTICLE =
  'https://memrisebeta.zendesk.com/hc/articles/13327335997329';
export const ZENDESK_MOBILE_MICROPHONE_ARTICLE =
  'https://memrisebeta.zendesk.com/hc/articles/13327869078161';
